export default {
  resultMatchesLogs: {
    messages: [],
  },
  lastUpdateTimestamp: '',
};
